module.exports = __webpack_public_path__ + "static/media/14-6.b435f3e7.mp3";